import { useSyncExternalStore } from "react";

/** The width below which the site is laid out for a phone. It matches the stylesheets. */
const QUERY = "(max-width: 860px)";

function subscribe(onChange: () => void): () => void {
  const media = window.matchMedia(QUERY);
  media.addEventListener("change", onChange);
  return () => media.removeEventListener("change", onChange);
}

/** True on a phone-width window, where what cannot sit side by side takes turns instead. */
export function useNarrowScreen(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => window.matchMedia(QUERY).matches,
    () => false,
  );
}
